var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"efb33a1ac91664b6f4584e220bbfc55c65a49f42"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["busbud-pubweb-prod@busbudcom"]={id:"efb33a1ac91664b6f4584e220bbfc55c65a49f42"};
      